import React from 'react'
import { useLanguage } from "../../LanguageContext";
import "./Benefits.scss"

const Benefits = () => {
    const { t } = useLanguage();
  return (
   <div className="benefits-section">

        <div className="benefitsHeading">
          <h2>{t("benefits_title_3")}</h2>
          <p className="primary">{t("benefits_title_3_description")}</p>
        </div>
        
        <div className="benefits-grid">
          <div className="benefit-item">
            <i className="fas fa-tachometer-alt"></i>
            <h3>{t("benefits_title_3_1")}</h3>
            <p className="secondary">{t("benefits_title_3_1_description")}</p>
          </div>
          <div className="benefit-item">
            <i className="fas fa-globe"></i>
            <h3>{t("benefits_title_3_2")}</h3>
            <p className="secondary">{t("benefits_title_3_2_description")}</p>
          </div>
          <div className="benefit-item">
            <i className="fas fa-chart-line"></i>
            <h3>{t("benefits_title_3_3")}</h3>
            <p className="secondary">{t("benefits_title_3_3_description")}</p>
          </div>
          <div className="benefit-item">
            <i className="fas fa-user-shield"></i>
              <h3>{t("benefits_title_3_4")}</h3>
            <p className="secondary">{t("benefits_title_3_4_description")}</p>
          </div>
          <div className="benefit-item">
            <i className="fas fa-brain"></i>
            <h3>{t("benefits_title_3_5")}</h3>
            <p className="secondary">{t("benefits_title_3_5_description")}</p>
          </div>
          <div className="benefit-item">
            <i className="fas fa-plug"></i>
            <h3>{t("benefits_title_3_6")}</h3>
            <p className="secondary">{t("benefits_title_3_6_description")}</p>
          </div>
        </div>
      </div>
  )
}

export default Benefits